<template>
  <section class="content">
    <!-- Default box -->
    <div
      class="card card-solid"
      :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
    >
      <div class="card-header pb-0">
        <div class="row">
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกสาขา</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="branch"
              >
                <option value="0">-- ทุกสาขา --</option>
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                >{{ b.branch_name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกจุดขาย</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="host"
              >
                <option value="0">-- ทุกจุดขาย --</option>
                <option
                  v-for="(h, i) in host_list"
                  :key="'host' + i"
                  :value="h"
                >{{ h.host_name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >จากวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="startDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >ถึงวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="endDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="getReport"
            >
              <i class="fas fa-redo"></i> ประมวลผล
            </button>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/pdf/report_holding_cus.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                :disabled="calAmountBranchAll(report_data) < 1"
                class="btn btn-primary btn-block"
              >
                <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
              </button>
            </form>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/excel/report_holding_cus.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                :disabled="calAmountBranchAll(report_data) < 1"
                class="btn btn-info btn-block"
              >
                <i class="far fa-file-excel"></i> บันทึกเป็น Excel
              </button>
            </form>
          </div>
        </div>
        <div
          class="text-center pt-3"
          v-if="report_data.length < 1"
        >
          <h5>ไม่มีข้อมูล</h5>
        </div>
        <div
          class="table-responsive-sm mt-3"
          v-for="(c, i) in report_data"
          :key="'c' + i"
          v-show="c.length > 0"
        >
          <h4 class="m-1 p-1">
            สาขา: {{ (c[0])? c[0]['branch_name'] || '-' : '-' }}
            &nbsp;&nbsp;&nbsp;&nbsp; จุดขาย: {{ (c[0])? c[0]['host_code'] || '-' : '-' }}
          </h4>
          <table
            id="sendMoney"
            class="table table-bordered"
            v-for="(c, i) in c"
            :key="'c' + i"
          >
            <tbody>
              <tr style="background: #fffed4;">
                <th colspan="6">ลูกค้า: {{ c.ar_name }}</th>
              </tr>
              <tr style="background: #fffed4;">
                <th colspan="2">เลขที่ใบพักบิล: {{ c.doc_no }}</th>
                <th colspan="2">วันที่: {{ dateFormatAndTime(c.doc_date) }}</th>
                <th colspan="2">ส่วนลด: {{ numberFormatDecimal(c.discount_amount) }}</th>
              </tr>
              <tr
                class="text-center"
                style="background: #ebf6ff;"
              >
                <th>บาร์โค้ด</th>
                <th>รายละอียด</th>
                <th>ราคาต่อหน่วย</th>
                <th>จำนวน</th>
                <th>ส่วนลด</th>
                <th>รวม</th>
              </tr>
              <tr
                v-for="(s, i) in c.sub"
                :key="'csub' + i"
              >
                <td>{{ s.item_barcode }}</td>
                <td>{{ s.item_name }}</td>
                <td class="text-right">{{ numberFormatDecimal(s.normal_price) }}</td>
                <td class="text-right">{{ numberFormatDecimal(s.qty) }}</td>
                <td class="text-right">0.00</td>
                <td class="text-right">{{ numberFormatDecimal(s.amount) }}</td>
              </tr>
              <tr>
                <td
                  class="text-right"
                  colspan="6"
                >### รวมรายการ: {{ c.sub.length }} ###</td>
              </tr>
              <tr>
                <td colspan="2">Remark: {{ c.description || '-' }}</td>
                <td style="background: #ebf6ff;">รวมพักบิล: {{ c.doc_no }}</td>
                <td class="text-right">{{ numberFormatDecimal(calQTY(c.sub)) }}</td>
                <td
                  class="text-right"
                  style="background: #ffd5d4;"
                >0.00</td>
                <td
                  class="text-right"
                  style="background: #e2ffd4;"
                >{{ numberFormatDecimal(calAmount(c.sub)) }}</td>
              </tr>
            </tbody>
          </table>
          <h5>รวมสาขา: {{ (c[0])? c[0]['branch_name'] || '-' : '-' }}: {{ numberFormatDecimal(calAmountBranch(c)) }} บาท</h5>
        </div>
        <table style="width: 100%;" v-if="calAmountBranchAll(report_data) > 0">
          <tr>
            <th
              style="background: #eeffeb; text-align: left;"
              class="pt-2 pl-2 pb-0"
            >
              <h5>รวมทุกสาขา: {{ numberFormatDecimal(calAmountBranchAll(report_data)) }} บาท</h5>
            </th>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>


<script>
import moment from 'moment'
import api from '../services/service_report'
import apipos from '../services/service_pos'

export default {
  data () {
    return {
      report_data: [],
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      branch: 0,
      host_list: [],
      host: null
    }
  },
  methods: {
    getReport () {
      var branch = 0
      this.report_data = []
      this.form_data = ''
      if (this.branch !== 0) {
        branch = this.branch.id
      }
      var obj = {
        id: branch,
        begin_date: this.dateDMY(this.startDate),
        end_date: this.dateDMY(this.endDate),
        company_id: 1,
        host_code: this.host.host_code,
        branch_id: 1
      }
      this.$store.state.isLoading = true
      api.holdingByCus(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          this.$store.state.isLoading = false
          if (result.response === 'success') {
            this.report_data = result.data
            console.log(this.report_data)
            this.form_data = JSON.stringify(this.report_data)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    getHost () {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            // this.getReport()
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    calQTY (obj) {
      var total = 0
      obj.forEach(v => {
        total += v['qty']
      })
      return total
    },
    calAmount (obj) {
      var total = 0
      obj.forEach(v => {
        total += v['amount']
      })
      return total
    },
    calAmountBranch (obj) {
      var total = 0
      obj.forEach(v => {
        total += v['total_amount']
      })
      return total
    },
    calAmountBranchAll (obj) {
      var total = 0
      obj.forEach(v => {
        v.forEach(val => {
          total += val['total_amount']
        })
      })
      return total
    }
  },
  mounted () {
    this.checkUser()
    this.getHost()
    this.getBranch()
  }
}
</script>
<style scoped>
.head_table {
  background-color: #ffffad;
}
.head-branch {
  font-size: 18px;
  color: rgb(0, 0, 0);
  font-weight: bold;
}
.table .thead-dark th {
  color: #000000;
  background-color: #ffffad;
  border-color: #ffffad;
}
.table .thead-footer th {
  color: #000000;
  text-align: center;
  background-color: #ffff;
}
</style>



// WEBPACK FOOTER //
// src/views/report_holding_cus.vue